var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3783 1.57145C18.785 0.978166 17.9963 0.650879 17.1567 0.650879C16.3171 0.650879 15.5283 0.978166 14.9351 1.57145L2.50973 13.9968C2.07026 14.4362 1.77304 14.9902 1.65161 15.5997L0.828191 19.7017C0.805061 19.8151 0.840912 19.933 0.923023 20.0152C0.988943 20.0811 1.07684 20.1169 1.1682 20.1169C1.19017 20.1169 1.2133 20.1146 1.23528 20.11L5.34429 19.2958C5.95723 19.1744 6.5135 18.8772 6.95528 18.4354L19.3783 6.01352C20.603 4.7888 20.603 2.79617 19.3783 1.57145ZM6.46492 17.9462C6.12145 18.2897 5.68661 18.5221 5.21013 18.6158L1.61113 19.3282L2.33278 15.735C2.42762 15.2608 2.65892 14.8283 3.00124 14.486L10.9035 6.58483L14.3649 10.0462L6.46492 17.9462ZM18.8879 5.52317L14.8553 9.55585L11.3939 6.09448L15.4266 2.0618C15.8892 1.5992 16.5033 1.34477 17.1567 1.34477C17.8101 1.34477 18.4253 1.5992 18.8868 2.0618C19.8409 3.0159 19.8409 4.56907 18.8868 5.52317H18.8879Z",
    fill: "#EE7628",
    stroke: "#EE7628",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.6005cf5d17928da0954edd386f9f579a.svg";
export { ForwardRef as ReactComponent };